import React from 'react';

const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
  });

const Columns = (print) => {
	let columns = [
		{
			id: 'key',
			name: 'Clave',
			selector: row => row.key,
		},
		{
			id: 'full_name',
			name: 'Operador',
			selector: row => row.full_name,
			minWidth:'300px'
		},
		{
			id: 'attendances_count',
			name: 'Días laborados',
			center: true,
			selector: row => `${row.attendances_count ?? ''}`,
		},
		{
			id: 'percepcion',
			name: 'Percepcion',
			right: true,
			selector: row => `$ ${fm.format(row.percepcion ?? 0)}`,
		},
		{
			id: 'prima_dominical',
			name: 'Prima dominical',
			right: true,
			selector: row => `$ ${fm.format(row.prima_dominical ?? 0)}`,
			sortable: true,
		},
		{
			id: 'percepcion_total',
			name: 'Percepción total',
			right: true,
			selector: row => `$ ${fm.format(row.percepcion_total ?? 0, 2)}`,
		},
		{
			id: 'actions',
			name: 'Acciones',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Editar venta' onClick={() => print(row)}><i className="fas fa-print"></i></button>
					</div>
				</div>
				),
		}
	];
	return columns;
}

export default Columns;